module.exports = __webpack_public_path__ + "img/flag-03.ac98ec25.svg";